export const setFunctionName = <T>(name :string, f :T) :T => {
  if (typeof f === "function") {
    Object.defineProperty (f, "name", { value: name });
  }

  return f;
};

